import useMediaQuery from '@mui/material/useMediaQuery';

// The OS/browser-level signal only — the visitor's explicit "Reduce
// motion" toggle lives in AccessibilityPreferences and is combined with
// this at the call site (see AccessibilityPreferencesProvider.tsx), so the
// panel's Switch always reflects the visitor's own stored choice rather
// than a value that silently flips based on OS state.
export function useReducedMotion(): boolean {
  return useMediaQuery('(prefers-reduced-motion: reduce)', { noSsr: true });
}
